import React, { useState } from 'react';
import { Typography } from '@mui/material';
import {
  Container,
  StyledTabs,
  StyledTab,
  SidebarContainer,
  ContentContainer,
  SearchBar,
  FormItem,
} from './DocumentHubContainer.styles';
import { WillsTestamentsContainer } from '@containers/WillsTestamentsContainer';
import { WillCreatorContainer } from "@containers/WillCreatorContainer";

function DocumentHubContainer() {
  const [tabValue, setTabValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container>
      <SidebarContainer>
        <Typography variant="h5" sx={{ mb: 2 }}>Forms</Typography>

        <SearchBar
          placeholder="Search Form"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <FormItem label="Select Type">
            <Typography>Will & Testament</Typography>
        </FormItem>
        <FormItem label="Select Type">
            <Typography>NDA</Typography>
        </FormItem>
        <FormItem label="Select Type">
            <Typography>Labour Contract</Typography>
        </FormItem>
      </SidebarContainer>

      <ContentContainer>
        <StyledTabs value={tabValue} onChange={handleTabChange}>
          <StyledTab label="Send" />
          <StyledTab label="View" />
        </StyledTabs>

        {tabValue === 0 && <WillsTestamentsContainer />}
        {tabValue === 1 && <WillCreatorContainer />}
      </ContentContainer>
    </Container>
  );
}

export default DocumentHubContainer;